/*Profile*/
if(window.location.pathname=="/profile"){
    
    var cropper;    
        
    $(document).on("change", ".profile-picture-input", function(){        
        popup_open("cropper");
        var cropper_area = $(".cropper-area");
        
        if (this.files && this.files[0]) {
            var reader = new FileReader();
            var image = new Image();
            reader.onload = function (e) {
                image.src = e.target.result;
                cropper_area.html(image);
                cropper = new Cropper(image, {
                    aspectRatio: 1/1,
                    movable: false
                });
                
            }
            reader.readAsDataURL(this.files[0]);
        }
        $(this).replaceWith($(this).val('').clone(true));
        
    });
    
    $(document).on("click", ".cropper-save", function(){
        cropper.getCroppedCanvas().toBlob((blob) => {
        const formData = new FormData();

        formData.append('avatar', blob);
        
            // Use `jQuery.ajax` method
            $.ajax('/api/profile/update_avatar', {
                method: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success(response) {                    
                    $(".profile-img").attr("src", "/storage/avatars/"+response['file']);
                    var msg = response['message'];
                    if(typeof response['error'] !== 'undefined'){
                        var alert = $("<div class='popover-alert'></div>");
                        alert.appendTo($("body")).popover({
                            "placement":"left",
                            "template":popover_templates.failure,
                            "title":"Failure",
                            "content":msg,
                            "delay":{"show":0, "hide":250}
                        }).popover("show");                      
                    }else{
                        var alert = $("<div class='popover-alert'></div>");
                        alert.appendTo($("body")).popover({
                            "placement":"left",
                            "template":popover_templates.success,
                            "title":"Saved",
                            "content":msg,
                            "delay":{"show":0, "hide":250}
                        }).popover("show");
                    }
                    setTimeout(function(){
                        alert.popover("dispose");
                    }, 2500);
                    popup_close("cropper");
                },
                error(response) {
                    var msg = "Something went wrong please try again.";
                    
                    if(typeof response['responseJSON'] !== 'undefined'){
                        if(typeof response['responseJSON']['message'] !== 'undefined'){
                            msg = response['responseJSON']['message'];
                        }
                    }
                    
                    var alert = $("<div class='popover-alert'></div>");
                    alert.appendTo($("body")).popover({
                        "placement":"left",                                                                         
                        "template":popover_templates.failure,
                        "title":"Failure",
                        "content":msg,
                        "delay":{"show":0, "hide":250}
                    }).popover("show");
                    
                    setTimeout(function(){
                        alert.popover("dispose");
                    }, 2500);
                },
            });
        });
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/profile.js